import { useEffect, useState } from "react";
import { CircleAlert } from "lucide-react";
import { NavLink } from "react-router-dom";
import api from "@/lib/api";

export const MiningTabs = ({ claimableCount }) => {
  const [fallbackClaimableCount, setFallbackClaimableCount] = useState(null);
  const usesProvidedCount = Number.isFinite(claimableCount);

  useEffect(() => {
    if (usesProvidedCount) return undefined;
    let active = true;
    api.get("/mining")
      .then((response) => {
        if (active) setFallbackClaimableCount(response.data?.discoveries?.claimable_count || 0);
      })
      .catch(() => {
        if (active) setFallbackClaimableCount(0);
      });
    return () => { active = false; };
  }, [usesProvidedCount]);

  const readyRewards = usesProvidedCount ? claimableCount : (fallbackClaimableCount || 0);
  const tabClass = ({ isActive }) => [
    "px-3 py-1.5 border text-xs font-cinzel uppercase tracking-[0.16em] transition-colors rounded-sm",
    isActive ? "border-amber-500 bg-amber-950/20 text-amber-300" : "border-zinc-800 text-zinc-400 hover:border-amber-700/40 hover:text-amber-300",
  ].join(" ");

  return (
    <div data-testid="mining-subnav" className="flex flex-wrap gap-2">
      <NavLink data-testid="mining-tab-overview" to="/mining" end className={tabClass}>
        Mining Overview
      </NavLink>
      <NavLink data-testid="mining-tab-smelting" to="/mining/smelting" className={tabClass}>
        Smelting
      </NavLink>
      <NavLink data-testid="mining-tab-smithing" to="/mining/smithing" className={tabClass}>
        Smithing
      </NavLink>
      <NavLink data-testid="mining-tab-rewards" to="/mining/rewards" className={tabClass}>
        <span>Discovery Rewards</span>
        {readyRewards > 0 && (
          <span data-testid="mining-tab-rewards-alert" title={`${readyRewards} discovery reward${readyRewards === 1 ? "" : "s"} ready to claim`} className="ml-1 inline-flex align-middle text-amber-300">
            <CircleAlert size={14} aria-hidden="true" />
            <span className="sr-only">{readyRewards} discovery reward{readyRewards === 1 ? "" : "s"} ready to claim</span>
          </span>
        )}
      </NavLink>
      <NavLink data-testid="mining-tab-journal" to="/mining/journal" className={tabClass}>
        Expedition Journal
      </NavLink>
      <NavLink data-testid="mining-tab-rankings" to="/mining/rankings" className={tabClass}>
        Mining Rankings
      </NavLink>
    </div>
  );
};